<app-type-lotsFNS-simple
[uid]="getUid()"
[parentForm]="parentForm"

[disabled]="disabled"
[initial]="fnSimpleInitial"
></app-type-lotsFNS-simple>